import type { SessionDeviceInfo } from "./store";

export interface GaiaGuideDevice {
    make?: string;
    model?: string;
    source: "ozmo" | "asurion";
}

/**
 * Maps GAIA's device payload onto the `{ make, model }` shape the guided flow already uses.
 *
 * `externalDevices` (Ozmo) is preferred over `detectedDevices`, which is a 0.8 Levenshtein match and so
 * returns confident near-misses ("iphone 19" → "Apple iPhone 17"). `model` comes from `name`, since
 * GAIA's own `model` is a hardware SKU (`iPhone16,1`) that means nothing to an expert or to Simplr.
 */
export const selectGaiaGuideDevice = (deviceInfo?: Partial<SessionDeviceInfo>): GaiaGuideDevice | undefined => {
    const ozmo = deviceInfo?.externalDevices?.[0];
    if (ozmo?.name || ozmo?.oem) {
        return { make: ozmo.oem || undefined, model: ozmo.name || undefined, source: "ozmo" };
    }

    const catalog = deviceInfo?.detectedDevices?.[0];
    if (catalog?.name || catalog?.oem) {
        return { make: catalog.oem || undefined, model: catalog.name || undefined, source: "asurion" };
    }

    return undefined;
};
